import { render, staticRenderFns } from "./CeisaBarangImporPungutan.vue?vue&type=template&id=1f424b6c&scoped=true&"
import script from "./CeisaBarangImporPungutan.vue?vue&type=script&lang=js&"
export * from "./CeisaBarangImporPungutan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f424b6c",
  null
  
)

export default component.exports